/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as BRouteImport } from './routes/_b';
import { Route as BPRouteImport } from './routes/_b._p';
import { Route as BPIndexRouteImport } from './routes/_b._p.index';
import { Route as BPCompanyRouteImport } from './routes/_b._p._company';
import { Route as BPLibraryRouteImport } from './routes/_b._p._library';
import { Route as BPForbiddenRouteImport } from './routes/_b._p.forbidden';
import { Route as BPCompanyCompanyRouteImport } from './routes/_b._p._company.company';
import { Route as BPCompanyUsersRouteImport } from './routes/_b._p._company.users';
import { Route as BPLibraryCategoriesRouteImport } from './routes/_b._p._library.categories';
import { Route as BPLibraryChecklistsRouteImport } from './routes/_b._p._library.checklists';
import { Route as BPLibraryLocationsRouteImport } from './routes/_b._p._library.locations';
import { Route as BPLibrarySeveritiesRouteImport } from './routes/_b._p._library.severities';
import { Route as BPLibraryTagsRouteImport } from './routes/_b._p._library.tags';
import { Route as BPAssetsAssetIdRouteImport } from './routes/_b._p.assets.$assetId';
import { Route as BPAssetsCreateRouteImport } from './routes/_b._p.assets.create';
import { Route as BPInspectionsProjectIdRouteImport } from './routes/_b._p.inspections.$projectId';
import { Route as BPInspectionsCreateRouteImport } from './routes/_b._p.inspections.create';
import { Route as BPSitesSiteIdRouteImport } from './routes/_b._p.sites.$siteId';
import { Route as BPSitesCreateRouteImport } from './routes/_b._p.sites.create';
import { Route as BPCompanyCompanyDocumentsRouteImport } from './routes/_b._p._company.company_.documents';
import { Route as BPCompanyUsersUserIdRouteImport } from './routes/_b._p._company.users_.$userId';
import { Route as BPCompanyUsersInviteRouteImport } from './routes/_b._p._company.users_.invite';
import { Route as BPLibraryCategoriesCategoryIdRouteImport } from './routes/_b._p._library.categories.$categoryId';
import { Route as BPLibraryCategoriesCreateRouteImport } from './routes/_b._p._library.categories.create';
import { Route as BPLibraryChecklistsChecklistTemplateIdRouteImport } from './routes/_b._p._library.checklists.$checklistTemplateId';
import { Route as BPLibraryChecklistsCreateRouteImport } from './routes/_b._p._library.checklists.create';
import { Route as BPLibraryLocationsCreateRouteImport } from './routes/_b._p._library.locations.create';
import { Route as BPLibraryLocationsLayoutTemplateIdRouteImport } from './routes/_b._p._library.locations_.$layoutTemplateId';
import { Route as BPLibrarySeveritiesSeverityIdRouteImport } from './routes/_b._p._library.severities.$severityId';
import { Route as BPLibrarySeveritiesCreateRouteImport } from './routes/_b._p._library.severities.create';
import { Route as BPLibraryTagsTagIdRouteImport } from './routes/_b._p._library.tags.$tagId';
import { Route as BPLibraryTagsCreateRouteImport } from './routes/_b._p._library.tags.create';
import { Route as BPAssetsUpdateAssetIdRouteImport } from './routes/_b._p.assets.update.$assetId';
import { Route as BPInspectionsUpdateProjectIdRouteImport } from './routes/_b._p.inspections.update.$projectId';
import { Route as BPSitesUpdateSiteIdRouteImport } from './routes/_b._p.sites.update.$siteId';
import { Route as BPCompanyUsersUpdateUserIdRouteImport } from './routes/_b._p._company.users_.update.$userId';
import { Route as BPLibraryCategoriesPresetPresetIdRouteImport } from './routes/_b._p._library.categories.preset.$presetId';
import { Route as BPLibraryCategoriesPresetCreateRouteImport } from './routes/_b._p._library.categories.preset.create';
import { Route as BPLibraryCategoriesUpdateCategoryIdRouteImport } from './routes/_b._p._library.categories.update.$categoryId';
import { Route as BPLibraryChecklistsUpdateChecklistTemplateIdRouteImport } from './routes/_b._p._library.checklists.update.$checklistTemplateId';
import { Route as BPLibraryLocationsUpdateLayoutTemplateIdRouteImport } from './routes/_b._p._library.locations.update.$layoutTemplateId';
import { Route as BPLibraryLocationsLayoutTemplateIdCreateRouteImport } from './routes/_b._p._library.locations_.$layoutTemplateId.create';
import { Route as BPLibraryTagsUpdateTagIdRouteImport } from './routes/_b._p._library.tags.update.$tagId';
import { Route as BPLibraryLocationsLayoutTemplateIdUpdateLayerTemplateIdRouteImport } from './routes/_b._p._library.locations_.$layoutTemplateId.update.$layerTemplateId';

const BRoute = BRouteImport.update({
  id: '/_b',
  getParentRoute: () => rootRouteImport,
} as any);
const BPRoute = BPRouteImport.update({
  id: '/_p',
  getParentRoute: () => BRoute,
} as any);
const BPIndexRoute = BPIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BPRoute,
} as any);
const BPCompanyRoute = BPCompanyRouteImport.update({
  id: '/_company',
  getParentRoute: () => BPRoute,
} as any);
const BPLibraryRoute = BPLibraryRouteImport.update({
  id: '/_library',
  getParentRoute: () => BPRoute,
} as any);
const BPForbiddenRoute = BPForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => BPRoute,
} as any);
const BPCompanyCompanyRoute = BPCompanyCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => BPCompanyRoute,
} as any);
const BPCompanyUsersRoute = BPCompanyUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => BPCompanyRoute,
} as any);
const BPLibraryCategoriesRoute = BPLibraryCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => BPLibraryRoute,
} as any);
const BPLibraryChecklistsRoute = BPLibraryChecklistsRouteImport.update({
  id: '/checklists',
  path: '/checklists',
  getParentRoute: () => BPLibraryRoute,
} as any);
const BPLibraryLocationsRoute = BPLibraryLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => BPLibraryRoute,
} as any);
const BPLibrarySeveritiesRoute = BPLibrarySeveritiesRouteImport.update({
  id: '/severities',
  path: '/severities',
  getParentRoute: () => BPLibraryRoute,
} as any);
const BPLibraryTagsRoute = BPLibraryTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => BPLibraryRoute,
} as any);
const BPAssetsAssetIdRoute = BPAssetsAssetIdRouteImport.update({
  id: '/assets/$assetId',
  path: '/assets/$assetId',
  getParentRoute: () => BPRoute,
} as any);
const BPAssetsCreateRoute = BPAssetsCreateRouteImport.update({
  id: '/assets/create',
  path: '/assets/create',
  getParentRoute: () => BPRoute,
} as any);
const BPInspectionsProjectIdRoute = BPInspectionsProjectIdRouteImport.update({
  id: '/inspections/$projectId',
  path: '/inspections/$projectId',
  getParentRoute: () => BPRoute,
} as any);
const BPInspectionsCreateRoute = BPInspectionsCreateRouteImport.update({
  id: '/inspections/create',
  path: '/inspections/create',
  getParentRoute: () => BPRoute,
} as any);
const BPSitesSiteIdRoute = BPSitesSiteIdRouteImport.update({
  id: '/sites/$siteId',
  path: '/sites/$siteId',
  getParentRoute: () => BPRoute,
} as any);
const BPSitesCreateRoute = BPSitesCreateRouteImport.update({
  id: '/sites/create',
  path: '/sites/create',
  getParentRoute: () => BPRoute,
} as any);
const BPCompanyCompanyDocumentsRoute =
  BPCompanyCompanyDocumentsRouteImport.update({
    id: '/company_/documents',
    path: '/company/documents',
    getParentRoute: () => BPCompanyRoute,
  } as any);
const BPCompanyUsersUserIdRoute = BPCompanyUsersUserIdRouteImport.update({
  id: '/users_/$userId',
  path: '/users/$userId',
  getParentRoute: () => BPCompanyRoute,
} as any);
const BPCompanyUsersInviteRoute = BPCompanyUsersInviteRouteImport.update({
  id: '/users_/invite',
  path: '/users/invite',
  getParentRoute: () => BPCompanyRoute,
} as any);
const BPLibraryCategoriesCategoryIdRoute =
  BPLibraryCategoriesCategoryIdRouteImport.update({
    id: '/$categoryId',
    path: '/$categoryId',
    getParentRoute: () => BPLibraryCategoriesRoute,
  } as any);
const BPLibraryCategoriesCreateRoute =
  BPLibraryCategoriesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BPLibraryCategoriesRoute,
  } as any);
const BPLibraryChecklistsChecklistTemplateIdRoute =
  BPLibraryChecklistsChecklistTemplateIdRouteImport.update({
    id: '/$checklistTemplateId',
    path: '/$checklistTemplateId',
    getParentRoute: () => BPLibraryChecklistsRoute,
  } as any);
const BPLibraryChecklistsCreateRoute =
  BPLibraryChecklistsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BPLibraryChecklistsRoute,
  } as any);
const BPLibraryLocationsCreateRoute =
  BPLibraryLocationsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BPLibraryLocationsRoute,
  } as any);
const BPLibraryLocationsLayoutTemplateIdRoute =
  BPLibraryLocationsLayoutTemplateIdRouteImport.update({
    id: '/locations_/$layoutTemplateId',
    path: '/locations/$layoutTemplateId',
    getParentRoute: () => BPLibraryRoute,
  } as any);
const BPLibrarySeveritiesSeverityIdRoute =
  BPLibrarySeveritiesSeverityIdRouteImport.update({
    id: '/$severityId',
    path: '/$severityId',
    getParentRoute: () => BPLibrarySeveritiesRoute,
  } as any);
const BPLibrarySeveritiesCreateRoute =
  BPLibrarySeveritiesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BPLibrarySeveritiesRoute,
  } as any);
const BPLibraryTagsTagIdRoute = BPLibraryTagsTagIdRouteImport.update({
  id: '/$tagId',
  path: '/$tagId',
  getParentRoute: () => BPLibraryTagsRoute,
} as any);
const BPLibraryTagsCreateRoute = BPLibraryTagsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => BPLibraryTagsRoute,
} as any);
const BPAssetsUpdateAssetIdRoute = BPAssetsUpdateAssetIdRouteImport.update({
  id: '/assets/update/$assetId',
  path: '/assets/update/$assetId',
  getParentRoute: () => BPRoute,
} as any);
const BPInspectionsUpdateProjectIdRoute =
  BPInspectionsUpdateProjectIdRouteImport.update({
    id: '/inspections/update/$projectId',
    path: '/inspections/update/$projectId',
    getParentRoute: () => BPRoute,
  } as any);
const BPSitesUpdateSiteIdRoute = BPSitesUpdateSiteIdRouteImport.update({
  id: '/sites/update/$siteId',
  path: '/sites/update/$siteId',
  getParentRoute: () => BPRoute,
} as any);
const BPCompanyUsersUpdateUserIdRoute =
  BPCompanyUsersUpdateUserIdRouteImport.update({
    id: '/users_/update/$userId',
    path: '/users/update/$userId',
    getParentRoute: () => BPCompanyRoute,
  } as any);
const BPLibraryCategoriesPresetPresetIdRoute =
  BPLibraryCategoriesPresetPresetIdRouteImport.update({
    id: '/preset/$presetId',
    path: '/preset/$presetId',
    getParentRoute: () => BPLibraryCategoriesRoute,
  } as any);
const BPLibraryCategoriesPresetCreateRoute =
  BPLibraryCategoriesPresetCreateRouteImport.update({
    id: '/preset/create',
    path: '/preset/create',
    getParentRoute: () => BPLibraryCategoriesRoute,
  } as any);
const BPLibraryCategoriesUpdateCategoryIdRoute =
  BPLibraryCategoriesUpdateCategoryIdRouteImport.update({
    id: '/update/$categoryId',
    path: '/update/$categoryId',
    getParentRoute: () => BPLibraryCategoriesRoute,
  } as any);
const BPLibraryChecklistsUpdateChecklistTemplateIdRoute =
  BPLibraryChecklistsUpdateChecklistTemplateIdRouteImport.update({
    id: '/update/$checklistTemplateId',
    path: '/update/$checklistTemplateId',
    getParentRoute: () => BPLibraryChecklistsRoute,
  } as any);
const BPLibraryLocationsUpdateLayoutTemplateIdRoute =
  BPLibraryLocationsUpdateLayoutTemplateIdRouteImport.update({
    id: '/update/$layoutTemplateId',
    path: '/update/$layoutTemplateId',
    getParentRoute: () => BPLibraryLocationsRoute,
  } as any);
const BPLibraryLocationsLayoutTemplateIdCreateRoute =
  BPLibraryLocationsLayoutTemplateIdCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BPLibraryLocationsLayoutTemplateIdRoute,
  } as any);
const BPLibraryTagsUpdateTagIdRoute =
  BPLibraryTagsUpdateTagIdRouteImport.update({
    id: '/update/$tagId',
    path: '/update/$tagId',
    getParentRoute: () => BPLibraryTagsRoute,
  } as any);
const BPLibraryLocationsLayoutTemplateIdUpdateLayerTemplateIdRoute =
  BPLibraryLocationsLayoutTemplateIdUpdateLayerTemplateIdRouteImport.update({
    id: '/update/$layerTemplateId',
    path: '/update/$layerTemplateId',
    getParentRoute: () => BPLibraryLocationsLayoutTemplateIdRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof BPIndexRoute;
  '/forbidden': typeof BPForbiddenRoute;
  '/company': typeof BPCompanyCompanyRoute;
  '/users': typeof BPCompanyUsersRoute;
  '/categories': typeof BPLibraryCategoriesRouteWithChildren;
  '/checklists': typeof BPLibraryChecklistsRouteWithChildren;
  '/locations': typeof BPLibraryLocationsRouteWithChildren;
  '/severities': typeof BPLibrarySeveritiesRouteWithChildren;
  '/tags': typeof BPLibraryTagsRouteWithChildren;
  '/assets/$assetId': typeof BPAssetsAssetIdRoute;
  '/assets/create': typeof BPAssetsCreateRoute;
  '/inspections/$projectId': typeof BPInspectionsProjectIdRoute;
  '/inspections/create': typeof BPInspectionsCreateRoute;
  '/sites/$siteId': typeof BPSitesSiteIdRoute;
  '/sites/create': typeof BPSitesCreateRoute;
  '/company/documents': typeof BPCompanyCompanyDocumentsRoute;
  '/users/$userId': typeof BPCompanyUsersUserIdRoute;
  '/users/invite': typeof BPCompanyUsersInviteRoute;
  '/categories/$categoryId': typeof BPLibraryCategoriesCategoryIdRoute;
  '/categories/create': typeof BPLibraryCategoriesCreateRoute;
  '/checklists/$checklistTemplateId': typeof BPLibraryChecklistsChecklistTemplateIdRoute;
  '/checklists/create': typeof BPLibraryChecklistsCreateRoute;
  '/locations/create': typeof BPLibraryLocationsCreateRoute;
  '/locations/$layoutTemplateId': typeof BPLibraryLocationsLayoutTemplateIdRouteWithChildren;
  '/severities/$severityId': typeof BPLibrarySeveritiesSeverityIdRoute;
  '/severities/create': typeof BPLibrarySeveritiesCreateRoute;
  '/tags/$tagId': typeof BPLibraryTagsTagIdRoute;
  '/tags/create': typeof BPLibraryTagsCreateRoute;
  '/assets/update/$assetId': typeof BPAssetsUpdateAssetIdRoute;
  '/inspections/update/$projectId': typeof BPInspectionsUpdateProjectIdRoute;
  '/sites/update/$siteId': typeof BPSitesUpdateSiteIdRoute;
  '/users/update/$userId': typeof BPCompanyUsersUpdateUserIdRoute;
  '/categories/preset/$presetId': typeof BPLibraryCategoriesPresetPresetIdRoute;
  '/categories/preset/create': typeof BPLibraryCategoriesPresetCreateRoute;
  '/categories/update/$categoryId': typeof BPLibraryCategoriesUpdateCategoryIdRoute;
  '/checklists/update/$checklistTemplateId': typeof BPLibraryChecklistsUpdateChecklistTemplateIdRoute;
  '/locations/update/$layoutTemplateId': typeof BPLibraryLocationsUpdateLayoutTemplateIdRoute;
  '/locations/$layoutTemplateId/create': typeof BPLibraryLocationsLayoutTemplateIdCreateRoute;
  '/tags/update/$tagId': typeof BPLibraryTagsUpdateTagIdRoute;
  '/locations/$layoutTemplateId/update/$layerTemplateId': typeof BPLibraryLocationsLayoutTemplateIdUpdateLayerTemplateIdRoute;
}
export interface FileRoutesByTo {
  '/': typeof BPIndexRoute;
  '/forbidden': typeof BPForbiddenRoute;
  '/company': typeof BPCompanyCompanyRoute;
  '/users': typeof BPCompanyUsersRoute;
  '/categories': typeof BPLibraryCategoriesRouteWithChildren;
  '/checklists': typeof BPLibraryChecklistsRouteWithChildren;
  '/locations': typeof BPLibraryLocationsRouteWithChildren;
  '/severities': typeof BPLibrarySeveritiesRouteWithChildren;
  '/tags': typeof BPLibraryTagsRouteWithChildren;
  '/assets/$assetId': typeof BPAssetsAssetIdRoute;
  '/assets/create': typeof BPAssetsCreateRoute;
  '/inspections/$projectId': typeof BPInspectionsProjectIdRoute;
  '/inspections/create': typeof BPInspectionsCreateRoute;
  '/sites/$siteId': typeof BPSitesSiteIdRoute;
  '/sites/create': typeof BPSitesCreateRoute;
  '/company/documents': typeof BPCompanyCompanyDocumentsRoute;
  '/users/$userId': typeof BPCompanyUsersUserIdRoute;
  '/users/invite': typeof BPCompanyUsersInviteRoute;
  '/categories/$categoryId': typeof BPLibraryCategoriesCategoryIdRoute;
  '/categories/create': typeof BPLibraryCategoriesCreateRoute;
  '/checklists/$checklistTemplateId': typeof BPLibraryChecklistsChecklistTemplateIdRoute;
  '/checklists/create': typeof BPLibraryChecklistsCreateRoute;
  '/locations/create': typeof BPLibraryLocationsCreateRoute;
  '/locations/$layoutTemplateId': typeof BPLibraryLocationsLayoutTemplateIdRouteWithChildren;
  '/severities/$severityId': typeof BPLibrarySeveritiesSeverityIdRoute;
  '/severities/create': typeof BPLibrarySeveritiesCreateRoute;
  '/tags/$tagId': typeof BPLibraryTagsTagIdRoute;
  '/tags/create': typeof BPLibraryTagsCreateRoute;
  '/assets/update/$assetId': typeof BPAssetsUpdateAssetIdRoute;
  '/inspections/update/$projectId': typeof BPInspectionsUpdateProjectIdRoute;
  '/sites/update/$siteId': typeof BPSitesUpdateSiteIdRoute;
  '/users/update/$userId': typeof BPCompanyUsersUpdateUserIdRoute;
  '/categories/preset/$presetId': typeof BPLibraryCategoriesPresetPresetIdRoute;
  '/categories/preset/create': typeof BPLibraryCategoriesPresetCreateRoute;
  '/categories/update/$categoryId': typeof BPLibraryCategoriesUpdateCategoryIdRoute;
  '/checklists/update/$checklistTemplateId': typeof BPLibraryChecklistsUpdateChecklistTemplateIdRoute;
  '/locations/update/$layoutTemplateId': typeof BPLibraryLocationsUpdateLayoutTemplateIdRoute;
  '/locations/$layoutTemplateId/create': typeof BPLibraryLocationsLayoutTemplateIdCreateRoute;
  '/tags/update/$tagId': typeof BPLibraryTagsUpdateTagIdRoute;
  '/locations/$layoutTemplateId/update/$layerTemplateId': typeof BPLibraryLocationsLayoutTemplateIdUpdateLayerTemplateIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_b': typeof BRouteWithChildren;
  '/_b/_p': typeof BPRouteWithChildren;
  '/_b/_p/_company': typeof BPCompanyRouteWithChildren;
  '/_b/_p/_library': typeof BPLibraryRouteWithChildren;
  '/_b/_p/forbidden': typeof BPForbiddenRoute;
  '/_b/_p/': typeof BPIndexRoute;
  '/_b/_p/_company/company': typeof BPCompanyCompanyRoute;
  '/_b/_p/_company/users': typeof BPCompanyUsersRoute;
  '/_b/_p/_library/categories': typeof BPLibraryCategoriesRouteWithChildren;
  '/_b/_p/_library/checklists': typeof BPLibraryChecklistsRouteWithChildren;
  '/_b/_p/_library/locations': typeof BPLibraryLocationsRouteWithChildren;
  '/_b/_p/_library/severities': typeof BPLibrarySeveritiesRouteWithChildren;
  '/_b/_p/_library/tags': typeof BPLibraryTagsRouteWithChildren;
  '/_b/_p/assets/$assetId': typeof BPAssetsAssetIdRoute;
  '/_b/_p/assets/create': typeof BPAssetsCreateRoute;
  '/_b/_p/inspections/$projectId': typeof BPInspectionsProjectIdRoute;
  '/_b/_p/inspections/create': typeof BPInspectionsCreateRoute;
  '/_b/_p/sites/$siteId': typeof BPSitesSiteIdRoute;
  '/_b/_p/sites/create': typeof BPSitesCreateRoute;
  '/_b/_p/_company/company_/documents': typeof BPCompanyCompanyDocumentsRoute;
  '/_b/_p/_company/users_/$userId': typeof BPCompanyUsersUserIdRoute;
  '/_b/_p/_company/users_/invite': typeof BPCompanyUsersInviteRoute;
  '/_b/_p/_library/categories/$categoryId': typeof BPLibraryCategoriesCategoryIdRoute;
  '/_b/_p/_library/categories/create': typeof BPLibraryCategoriesCreateRoute;
  '/_b/_p/_library/checklists/$checklistTemplateId': typeof BPLibraryChecklistsChecklistTemplateIdRoute;
  '/_b/_p/_library/checklists/create': typeof BPLibraryChecklistsCreateRoute;
  '/_b/_p/_library/locations/create': typeof BPLibraryLocationsCreateRoute;
  '/_b/_p/_library/locations_/$layoutTemplateId': typeof BPLibraryLocationsLayoutTemplateIdRouteWithChildren;
  '/_b/_p/_library/severities/$severityId': typeof BPLibrarySeveritiesSeverityIdRoute;
  '/_b/_p/_library/severities/create': typeof BPLibrarySeveritiesCreateRoute;
  '/_b/_p/_library/tags/$tagId': typeof BPLibraryTagsTagIdRoute;
  '/_b/_p/_library/tags/create': typeof BPLibraryTagsCreateRoute;
  '/_b/_p/assets/update/$assetId': typeof BPAssetsUpdateAssetIdRoute;
  '/_b/_p/inspections/update/$projectId': typeof BPInspectionsUpdateProjectIdRoute;
  '/_b/_p/sites/update/$siteId': typeof BPSitesUpdateSiteIdRoute;
  '/_b/_p/_company/users_/update/$userId': typeof BPCompanyUsersUpdateUserIdRoute;
  '/_b/_p/_library/categories/preset/$presetId': typeof BPLibraryCategoriesPresetPresetIdRoute;
  '/_b/_p/_library/categories/preset/create': typeof BPLibraryCategoriesPresetCreateRoute;
  '/_b/_p/_library/categories/update/$categoryId': typeof BPLibraryCategoriesUpdateCategoryIdRoute;
  '/_b/_p/_library/checklists/update/$checklistTemplateId': typeof BPLibraryChecklistsUpdateChecklistTemplateIdRoute;
  '/_b/_p/_library/locations/update/$layoutTemplateId': typeof BPLibraryLocationsUpdateLayoutTemplateIdRoute;
  '/_b/_p/_library/locations_/$layoutTemplateId/create': typeof BPLibraryLocationsLayoutTemplateIdCreateRoute;
  '/_b/_p/_library/tags/update/$tagId': typeof BPLibraryTagsUpdateTagIdRoute;
  '/_b/_p/_library/locations_/$layoutTemplateId/update/$layerTemplateId': typeof BPLibraryLocationsLayoutTemplateIdUpdateLayerTemplateIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/forbidden'
    | '/company'
    | '/users'
    | '/categories'
    | '/checklists'
    | '/locations'
    | '/severities'
    | '/tags'
    | '/assets/$assetId'
    | '/assets/create'
    | '/inspections/$projectId'
    | '/inspections/create'
    | '/sites/$siteId'
    | '/sites/create'
    | '/company/documents'
    | '/users/$userId'
    | '/users/invite'
    | '/categories/$categoryId'
    | '/categories/create'
    | '/checklists/$checklistTemplateId'
    | '/checklists/create'
    | '/locations/create'
    | '/locations/$layoutTemplateId'
    | '/severities/$severityId'
    | '/severities/create'
    | '/tags/$tagId'
    | '/tags/create'
    | '/assets/update/$assetId'
    | '/inspections/update/$projectId'
    | '/sites/update/$siteId'
    | '/users/update/$userId'
    | '/categories/preset/$presetId'
    | '/categories/preset/create'
    | '/categories/update/$categoryId'
    | '/checklists/update/$checklistTemplateId'
    | '/locations/update/$layoutTemplateId'
    | '/locations/$layoutTemplateId/create'
    | '/tags/update/$tagId'
    | '/locations/$layoutTemplateId/update/$layerTemplateId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/forbidden'
    | '/company'
    | '/users'
    | '/categories'
    | '/checklists'
    | '/locations'
    | '/severities'
    | '/tags'
    | '/assets/$assetId'
    | '/assets/create'
    | '/inspections/$projectId'
    | '/inspections/create'
    | '/sites/$siteId'
    | '/sites/create'
    | '/company/documents'
    | '/users/$userId'
    | '/users/invite'
    | '/categories/$categoryId'
    | '/categories/create'
    | '/checklists/$checklistTemplateId'
    | '/checklists/create'
    | '/locations/create'
    | '/locations/$layoutTemplateId'
    | '/severities/$severityId'
    | '/severities/create'
    | '/tags/$tagId'
    | '/tags/create'
    | '/assets/update/$assetId'
    | '/inspections/update/$projectId'
    | '/sites/update/$siteId'
    | '/users/update/$userId'
    | '/categories/preset/$presetId'
    | '/categories/preset/create'
    | '/categories/update/$categoryId'
    | '/checklists/update/$checklistTemplateId'
    | '/locations/update/$layoutTemplateId'
    | '/locations/$layoutTemplateId/create'
    | '/tags/update/$tagId'
    | '/locations/$layoutTemplateId/update/$layerTemplateId';
  id:
    | '__root__'
    | '/_b'
    | '/_b/_p'
    | '/_b/_p/_company'
    | '/_b/_p/_library'
    | '/_b/_p/forbidden'
    | '/_b/_p/'
    | '/_b/_p/_company/company'
    | '/_b/_p/_company/users'
    | '/_b/_p/_library/categories'
    | '/_b/_p/_library/checklists'
    | '/_b/_p/_library/locations'
    | '/_b/_p/_library/severities'
    | '/_b/_p/_library/tags'
    | '/_b/_p/assets/$assetId'
    | '/_b/_p/assets/create'
    | '/_b/_p/inspections/$projectId'
    | '/_b/_p/inspections/create'
    | '/_b/_p/sites/$siteId'
    | '/_b/_p/sites/create'
    | '/_b/_p/_company/company_/documents'
    | '/_b/_p/_company/users_/$userId'
    | '/_b/_p/_company/users_/invite'
    | '/_b/_p/_library/categories/$categoryId'
    | '/_b/_p/_library/categories/create'
    | '/_b/_p/_library/checklists/$checklistTemplateId'
    | '/_b/_p/_library/checklists/create'
    | '/_b/_p/_library/locations/create'
    | '/_b/_p/_library/locations_/$layoutTemplateId'
    | '/_b/_p/_library/severities/$severityId'
    | '/_b/_p/_library/severities/create'
    | '/_b/_p/_library/tags/$tagId'
    | '/_b/_p/_library/tags/create'
    | '/_b/_p/assets/update/$assetId'
    | '/_b/_p/inspections/update/$projectId'
    | '/_b/_p/sites/update/$siteId'
    | '/_b/_p/_company/users_/update/$userId'
    | '/_b/_p/_library/categories/preset/$presetId'
    | '/_b/_p/_library/categories/preset/create'
    | '/_b/_p/_library/categories/update/$categoryId'
    | '/_b/_p/_library/checklists/update/$checklistTemplateId'
    | '/_b/_p/_library/locations/update/$layoutTemplateId'
    | '/_b/_p/_library/locations_/$layoutTemplateId/create'
    | '/_b/_p/_library/tags/update/$tagId'
    | '/_b/_p/_library/locations_/$layoutTemplateId/update/$layerTemplateId';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  BRoute: typeof BRouteWithChildren;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_b': {
      id: '/_b';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof BRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_b/_p': {
      id: '/_b/_p';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof BPRouteImport;
      parentRoute: typeof BRoute;
    };
    '/_b/_p/': {
      id: '/_b/_p/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof BPIndexRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/_company': {
      id: '/_b/_p/_company';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof BPCompanyRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/_library': {
      id: '/_b/_p/_library';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof BPLibraryRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/forbidden': {
      id: '/_b/_p/forbidden';
      path: '/forbidden';
      fullPath: '/forbidden';
      preLoaderRoute: typeof BPForbiddenRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/_company/company': {
      id: '/_b/_p/_company/company';
      path: '/company';
      fullPath: '/company';
      preLoaderRoute: typeof BPCompanyCompanyRouteImport;
      parentRoute: typeof BPCompanyRoute;
    };
    '/_b/_p/_company/users': {
      id: '/_b/_p/_company/users';
      path: '/users';
      fullPath: '/users';
      preLoaderRoute: typeof BPCompanyUsersRouteImport;
      parentRoute: typeof BPCompanyRoute;
    };
    '/_b/_p/_library/categories': {
      id: '/_b/_p/_library/categories';
      path: '/categories';
      fullPath: '/categories';
      preLoaderRoute: typeof BPLibraryCategoriesRouteImport;
      parentRoute: typeof BPLibraryRoute;
    };
    '/_b/_p/_library/checklists': {
      id: '/_b/_p/_library/checklists';
      path: '/checklists';
      fullPath: '/checklists';
      preLoaderRoute: typeof BPLibraryChecklistsRouteImport;
      parentRoute: typeof BPLibraryRoute;
    };
    '/_b/_p/_library/locations': {
      id: '/_b/_p/_library/locations';
      path: '/locations';
      fullPath: '/locations';
      preLoaderRoute: typeof BPLibraryLocationsRouteImport;
      parentRoute: typeof BPLibraryRoute;
    };
    '/_b/_p/_library/severities': {
      id: '/_b/_p/_library/severities';
      path: '/severities';
      fullPath: '/severities';
      preLoaderRoute: typeof BPLibrarySeveritiesRouteImport;
      parentRoute: typeof BPLibraryRoute;
    };
    '/_b/_p/_library/tags': {
      id: '/_b/_p/_library/tags';
      path: '/tags';
      fullPath: '/tags';
      preLoaderRoute: typeof BPLibraryTagsRouteImport;
      parentRoute: typeof BPLibraryRoute;
    };
    '/_b/_p/assets/$assetId': {
      id: '/_b/_p/assets/$assetId';
      path: '/assets/$assetId';
      fullPath: '/assets/$assetId';
      preLoaderRoute: typeof BPAssetsAssetIdRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/assets/create': {
      id: '/_b/_p/assets/create';
      path: '/assets/create';
      fullPath: '/assets/create';
      preLoaderRoute: typeof BPAssetsCreateRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/inspections/$projectId': {
      id: '/_b/_p/inspections/$projectId';
      path: '/inspections/$projectId';
      fullPath: '/inspections/$projectId';
      preLoaderRoute: typeof BPInspectionsProjectIdRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/inspections/create': {
      id: '/_b/_p/inspections/create';
      path: '/inspections/create';
      fullPath: '/inspections/create';
      preLoaderRoute: typeof BPInspectionsCreateRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/sites/$siteId': {
      id: '/_b/_p/sites/$siteId';
      path: '/sites/$siteId';
      fullPath: '/sites/$siteId';
      preLoaderRoute: typeof BPSitesSiteIdRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/sites/create': {
      id: '/_b/_p/sites/create';
      path: '/sites/create';
      fullPath: '/sites/create';
      preLoaderRoute: typeof BPSitesCreateRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/_company/company_/documents': {
      id: '/_b/_p/_company/company_/documents';
      path: '/company/documents';
      fullPath: '/company/documents';
      preLoaderRoute: typeof BPCompanyCompanyDocumentsRouteImport;
      parentRoute: typeof BPCompanyRoute;
    };
    '/_b/_p/_company/users_/$userId': {
      id: '/_b/_p/_company/users_/$userId';
      path: '/users/$userId';
      fullPath: '/users/$userId';
      preLoaderRoute: typeof BPCompanyUsersUserIdRouteImport;
      parentRoute: typeof BPCompanyRoute;
    };
    '/_b/_p/_company/users_/invite': {
      id: '/_b/_p/_company/users_/invite';
      path: '/users/invite';
      fullPath: '/users/invite';
      preLoaderRoute: typeof BPCompanyUsersInviteRouteImport;
      parentRoute: typeof BPCompanyRoute;
    };
    '/_b/_p/_library/categories/$categoryId': {
      id: '/_b/_p/_library/categories/$categoryId';
      path: '/$categoryId';
      fullPath: '/categories/$categoryId';
      preLoaderRoute: typeof BPLibraryCategoriesCategoryIdRouteImport;
      parentRoute: typeof BPLibraryCategoriesRoute;
    };
    '/_b/_p/_library/categories/create': {
      id: '/_b/_p/_library/categories/create';
      path: '/create';
      fullPath: '/categories/create';
      preLoaderRoute: typeof BPLibraryCategoriesCreateRouteImport;
      parentRoute: typeof BPLibraryCategoriesRoute;
    };
    '/_b/_p/_library/checklists/$checklistTemplateId': {
      id: '/_b/_p/_library/checklists/$checklistTemplateId';
      path: '/$checklistTemplateId';
      fullPath: '/checklists/$checklistTemplateId';
      preLoaderRoute: typeof BPLibraryChecklistsChecklistTemplateIdRouteImport;
      parentRoute: typeof BPLibraryChecklistsRoute;
    };
    '/_b/_p/_library/checklists/create': {
      id: '/_b/_p/_library/checklists/create';
      path: '/create';
      fullPath: '/checklists/create';
      preLoaderRoute: typeof BPLibraryChecklistsCreateRouteImport;
      parentRoute: typeof BPLibraryChecklistsRoute;
    };
    '/_b/_p/_library/locations/create': {
      id: '/_b/_p/_library/locations/create';
      path: '/create';
      fullPath: '/locations/create';
      preLoaderRoute: typeof BPLibraryLocationsCreateRouteImport;
      parentRoute: typeof BPLibraryLocationsRoute;
    };
    '/_b/_p/_library/locations_/$layoutTemplateId': {
      id: '/_b/_p/_library/locations_/$layoutTemplateId';
      path: '/locations/$layoutTemplateId';
      fullPath: '/locations/$layoutTemplateId';
      preLoaderRoute: typeof BPLibraryLocationsLayoutTemplateIdRouteImport;
      parentRoute: typeof BPLibraryRoute;
    };
    '/_b/_p/_library/severities/$severityId': {
      id: '/_b/_p/_library/severities/$severityId';
      path: '/$severityId';
      fullPath: '/severities/$severityId';
      preLoaderRoute: typeof BPLibrarySeveritiesSeverityIdRouteImport;
      parentRoute: typeof BPLibrarySeveritiesRoute;
    };
    '/_b/_p/_library/severities/create': {
      id: '/_b/_p/_library/severities/create';
      path: '/create';
      fullPath: '/severities/create';
      preLoaderRoute: typeof BPLibrarySeveritiesCreateRouteImport;
      parentRoute: typeof BPLibrarySeveritiesRoute;
    };
    '/_b/_p/_library/tags/$tagId': {
      id: '/_b/_p/_library/tags/$tagId';
      path: '/$tagId';
      fullPath: '/tags/$tagId';
      preLoaderRoute: typeof BPLibraryTagsTagIdRouteImport;
      parentRoute: typeof BPLibraryTagsRoute;
    };
    '/_b/_p/_library/tags/create': {
      id: '/_b/_p/_library/tags/create';
      path: '/create';
      fullPath: '/tags/create';
      preLoaderRoute: typeof BPLibraryTagsCreateRouteImport;
      parentRoute: typeof BPLibraryTagsRoute;
    };
    '/_b/_p/assets/update/$assetId': {
      id: '/_b/_p/assets/update/$assetId';
      path: '/assets/update/$assetId';
      fullPath: '/assets/update/$assetId';
      preLoaderRoute: typeof BPAssetsUpdateAssetIdRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/inspections/update/$projectId': {
      id: '/_b/_p/inspections/update/$projectId';
      path: '/inspections/update/$projectId';
      fullPath: '/inspections/update/$projectId';
      preLoaderRoute: typeof BPInspectionsUpdateProjectIdRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/sites/update/$siteId': {
      id: '/_b/_p/sites/update/$siteId';
      path: '/sites/update/$siteId';
      fullPath: '/sites/update/$siteId';
      preLoaderRoute: typeof BPSitesUpdateSiteIdRouteImport;
      parentRoute: typeof BPRoute;
    };
    '/_b/_p/_company/users_/update/$userId': {
      id: '/_b/_p/_company/users_/update/$userId';
      path: '/users/update/$userId';
      fullPath: '/users/update/$userId';
      preLoaderRoute: typeof BPCompanyUsersUpdateUserIdRouteImport;
      parentRoute: typeof BPCompanyRoute;
    };
    '/_b/_p/_library/categories/preset/$presetId': {
      id: '/_b/_p/_library/categories/preset/$presetId';
      path: '/preset/$presetId';
      fullPath: '/categories/preset/$presetId';
      preLoaderRoute: typeof BPLibraryCategoriesPresetPresetIdRouteImport;
      parentRoute: typeof BPLibraryCategoriesRoute;
    };
    '/_b/_p/_library/categories/preset/create': {
      id: '/_b/_p/_library/categories/preset/create';
      path: '/preset/create';
      fullPath: '/categories/preset/create';
      preLoaderRoute: typeof BPLibraryCategoriesPresetCreateRouteImport;
      parentRoute: typeof BPLibraryCategoriesRoute;
    };
    '/_b/_p/_library/categories/update/$categoryId': {
      id: '/_b/_p/_library/categories/update/$categoryId';
      path: '/update/$categoryId';
      fullPath: '/categories/update/$categoryId';
      preLoaderRoute: typeof BPLibraryCategoriesUpdateCategoryIdRouteImport;
      parentRoute: typeof BPLibraryCategoriesRoute;
    };
    '/_b/_p/_library/checklists/update/$checklistTemplateId': {
      id: '/_b/_p/_library/checklists/update/$checklistTemplateId';
      path: '/update/$checklistTemplateId';
      fullPath: '/checklists/update/$checklistTemplateId';
      preLoaderRoute: typeof BPLibraryChecklistsUpdateChecklistTemplateIdRouteImport;
      parentRoute: typeof BPLibraryChecklistsRoute;
    };
    '/_b/_p/_library/locations/update/$layoutTemplateId': {
      id: '/_b/_p/_library/locations/update/$layoutTemplateId';
      path: '/update/$layoutTemplateId';
      fullPath: '/locations/update/$layoutTemplateId';
      preLoaderRoute: typeof BPLibraryLocationsUpdateLayoutTemplateIdRouteImport;
      parentRoute: typeof BPLibraryLocationsRoute;
    };
    '/_b/_p/_library/locations_/$layoutTemplateId/create': {
      id: '/_b/_p/_library/locations_/$layoutTemplateId/create';
      path: '/create';
      fullPath: '/locations/$layoutTemplateId/create';
      preLoaderRoute: typeof BPLibraryLocationsLayoutTemplateIdCreateRouteImport;
      parentRoute: typeof BPLibraryLocationsLayoutTemplateIdRoute;
    };
    '/_b/_p/_library/tags/update/$tagId': {
      id: '/_b/_p/_library/tags/update/$tagId';
      path: '/update/$tagId';
      fullPath: '/tags/update/$tagId';
      preLoaderRoute: typeof BPLibraryTagsUpdateTagIdRouteImport;
      parentRoute: typeof BPLibraryTagsRoute;
    };
    '/_b/_p/_library/locations_/$layoutTemplateId/update/$layerTemplateId': {
      id: '/_b/_p/_library/locations_/$layoutTemplateId/update/$layerTemplateId';
      path: '/update/$layerTemplateId';
      fullPath: '/locations/$layoutTemplateId/update/$layerTemplateId';
      preLoaderRoute: typeof BPLibraryLocationsLayoutTemplateIdUpdateLayerTemplateIdRouteImport;
      parentRoute: typeof BPLibraryLocationsLayoutTemplateIdRoute;
    };
  }
}

interface BPCompanyRouteChildren {
  BPCompanyCompanyRoute: typeof BPCompanyCompanyRoute;
  BPCompanyUsersRoute: typeof BPCompanyUsersRoute;
  BPCompanyCompanyDocumentsRoute: typeof BPCompanyCompanyDocumentsRoute;
  BPCompanyUsersUserIdRoute: typeof BPCompanyUsersUserIdRoute;
  BPCompanyUsersInviteRoute: typeof BPCompanyUsersInviteRoute;
  BPCompanyUsersUpdateUserIdRoute: typeof BPCompanyUsersUpdateUserIdRoute;
}

const BPCompanyRouteChildren: BPCompanyRouteChildren = {
  BPCompanyCompanyRoute: BPCompanyCompanyRoute,
  BPCompanyUsersRoute: BPCompanyUsersRoute,
  BPCompanyCompanyDocumentsRoute: BPCompanyCompanyDocumentsRoute,
  BPCompanyUsersUserIdRoute: BPCompanyUsersUserIdRoute,
  BPCompanyUsersInviteRoute: BPCompanyUsersInviteRoute,
  BPCompanyUsersUpdateUserIdRoute: BPCompanyUsersUpdateUserIdRoute,
};

const BPCompanyRouteWithChildren = BPCompanyRoute._addFileChildren(
  BPCompanyRouteChildren,
);

interface BPLibraryCategoriesRouteChildren {
  BPLibraryCategoriesCategoryIdRoute: typeof BPLibraryCategoriesCategoryIdRoute;
  BPLibraryCategoriesCreateRoute: typeof BPLibraryCategoriesCreateRoute;
  BPLibraryCategoriesPresetPresetIdRoute: typeof BPLibraryCategoriesPresetPresetIdRoute;
  BPLibraryCategoriesPresetCreateRoute: typeof BPLibraryCategoriesPresetCreateRoute;
  BPLibraryCategoriesUpdateCategoryIdRoute: typeof BPLibraryCategoriesUpdateCategoryIdRoute;
}

const BPLibraryCategoriesRouteChildren: BPLibraryCategoriesRouteChildren = {
  BPLibraryCategoriesCategoryIdRoute: BPLibraryCategoriesCategoryIdRoute,
  BPLibraryCategoriesCreateRoute: BPLibraryCategoriesCreateRoute,
  BPLibraryCategoriesPresetPresetIdRoute:
    BPLibraryCategoriesPresetPresetIdRoute,
  BPLibraryCategoriesPresetCreateRoute: BPLibraryCategoriesPresetCreateRoute,
  BPLibraryCategoriesUpdateCategoryIdRoute:
    BPLibraryCategoriesUpdateCategoryIdRoute,
};

const BPLibraryCategoriesRouteWithChildren =
  BPLibraryCategoriesRoute._addFileChildren(BPLibraryCategoriesRouteChildren);

interface BPLibraryChecklistsRouteChildren {
  BPLibraryChecklistsChecklistTemplateIdRoute: typeof BPLibraryChecklistsChecklistTemplateIdRoute;
  BPLibraryChecklistsCreateRoute: typeof BPLibraryChecklistsCreateRoute;
  BPLibraryChecklistsUpdateChecklistTemplateIdRoute: typeof BPLibraryChecklistsUpdateChecklistTemplateIdRoute;
}

const BPLibraryChecklistsRouteChildren: BPLibraryChecklistsRouteChildren = {
  BPLibraryChecklistsChecklistTemplateIdRoute:
    BPLibraryChecklistsChecklistTemplateIdRoute,
  BPLibraryChecklistsCreateRoute: BPLibraryChecklistsCreateRoute,
  BPLibraryChecklistsUpdateChecklistTemplateIdRoute:
    BPLibraryChecklistsUpdateChecklistTemplateIdRoute,
};

const BPLibraryChecklistsRouteWithChildren =
  BPLibraryChecklistsRoute._addFileChildren(BPLibraryChecklistsRouteChildren);

interface BPLibraryLocationsRouteChildren {
  BPLibraryLocationsCreateRoute: typeof BPLibraryLocationsCreateRoute;
  BPLibraryLocationsUpdateLayoutTemplateIdRoute: typeof BPLibraryLocationsUpdateLayoutTemplateIdRoute;
}

const BPLibraryLocationsRouteChildren: BPLibraryLocationsRouteChildren = {
  BPLibraryLocationsCreateRoute: BPLibraryLocationsCreateRoute,
  BPLibraryLocationsUpdateLayoutTemplateIdRoute:
    BPLibraryLocationsUpdateLayoutTemplateIdRoute,
};

const BPLibraryLocationsRouteWithChildren =
  BPLibraryLocationsRoute._addFileChildren(BPLibraryLocationsRouteChildren);

interface BPLibrarySeveritiesRouteChildren {
  BPLibrarySeveritiesSeverityIdRoute: typeof BPLibrarySeveritiesSeverityIdRoute;
  BPLibrarySeveritiesCreateRoute: typeof BPLibrarySeveritiesCreateRoute;
}

const BPLibrarySeveritiesRouteChildren: BPLibrarySeveritiesRouteChildren = {
  BPLibrarySeveritiesSeverityIdRoute: BPLibrarySeveritiesSeverityIdRoute,
  BPLibrarySeveritiesCreateRoute: BPLibrarySeveritiesCreateRoute,
};

const BPLibrarySeveritiesRouteWithChildren =
  BPLibrarySeveritiesRoute._addFileChildren(BPLibrarySeveritiesRouteChildren);

interface BPLibraryTagsRouteChildren {
  BPLibraryTagsTagIdRoute: typeof BPLibraryTagsTagIdRoute;
  BPLibraryTagsCreateRoute: typeof BPLibraryTagsCreateRoute;
  BPLibraryTagsUpdateTagIdRoute: typeof BPLibraryTagsUpdateTagIdRoute;
}

const BPLibraryTagsRouteChildren: BPLibraryTagsRouteChildren = {
  BPLibraryTagsTagIdRoute: BPLibraryTagsTagIdRoute,
  BPLibraryTagsCreateRoute: BPLibraryTagsCreateRoute,
  BPLibraryTagsUpdateTagIdRoute: BPLibraryTagsUpdateTagIdRoute,
};

const BPLibraryTagsRouteWithChildren = BPLibraryTagsRoute._addFileChildren(
  BPLibraryTagsRouteChildren,
);

interface BPLibraryLocationsLayoutTemplateIdRouteChildren {
  BPLibraryLocationsLayoutTemplateIdCreateRoute: typeof BPLibraryLocationsLayoutTemplateIdCreateRoute;
  BPLibraryLocationsLayoutTemplateIdUpdateLayerTemplateIdRoute: typeof BPLibraryLocationsLayoutTemplateIdUpdateLayerTemplateIdRoute;
}

const BPLibraryLocationsLayoutTemplateIdRouteChildren: BPLibraryLocationsLayoutTemplateIdRouteChildren =
  {
    BPLibraryLocationsLayoutTemplateIdCreateRoute:
      BPLibraryLocationsLayoutTemplateIdCreateRoute,
    BPLibraryLocationsLayoutTemplateIdUpdateLayerTemplateIdRoute:
      BPLibraryLocationsLayoutTemplateIdUpdateLayerTemplateIdRoute,
  };

const BPLibraryLocationsLayoutTemplateIdRouteWithChildren =
  BPLibraryLocationsLayoutTemplateIdRoute._addFileChildren(
    BPLibraryLocationsLayoutTemplateIdRouteChildren,
  );

interface BPLibraryRouteChildren {
  BPLibraryCategoriesRoute: typeof BPLibraryCategoriesRouteWithChildren;
  BPLibraryChecklistsRoute: typeof BPLibraryChecklistsRouteWithChildren;
  BPLibraryLocationsRoute: typeof BPLibraryLocationsRouteWithChildren;
  BPLibrarySeveritiesRoute: typeof BPLibrarySeveritiesRouteWithChildren;
  BPLibraryTagsRoute: typeof BPLibraryTagsRouteWithChildren;
  BPLibraryLocationsLayoutTemplateIdRoute: typeof BPLibraryLocationsLayoutTemplateIdRouteWithChildren;
}

const BPLibraryRouteChildren: BPLibraryRouteChildren = {
  BPLibraryCategoriesRoute: BPLibraryCategoriesRouteWithChildren,
  BPLibraryChecklistsRoute: BPLibraryChecklistsRouteWithChildren,
  BPLibraryLocationsRoute: BPLibraryLocationsRouteWithChildren,
  BPLibrarySeveritiesRoute: BPLibrarySeveritiesRouteWithChildren,
  BPLibraryTagsRoute: BPLibraryTagsRouteWithChildren,
  BPLibraryLocationsLayoutTemplateIdRoute:
    BPLibraryLocationsLayoutTemplateIdRouteWithChildren,
};

const BPLibraryRouteWithChildren = BPLibraryRoute._addFileChildren(
  BPLibraryRouteChildren,
);

interface BPRouteChildren {
  BPCompanyRoute: typeof BPCompanyRouteWithChildren;
  BPLibraryRoute: typeof BPLibraryRouteWithChildren;
  BPForbiddenRoute: typeof BPForbiddenRoute;
  BPIndexRoute: typeof BPIndexRoute;
  BPAssetsAssetIdRoute: typeof BPAssetsAssetIdRoute;
  BPAssetsCreateRoute: typeof BPAssetsCreateRoute;
  BPInspectionsProjectIdRoute: typeof BPInspectionsProjectIdRoute;
  BPInspectionsCreateRoute: typeof BPInspectionsCreateRoute;
  BPSitesSiteIdRoute: typeof BPSitesSiteIdRoute;
  BPSitesCreateRoute: typeof BPSitesCreateRoute;
  BPAssetsUpdateAssetIdRoute: typeof BPAssetsUpdateAssetIdRoute;
  BPInspectionsUpdateProjectIdRoute: typeof BPInspectionsUpdateProjectIdRoute;
  BPSitesUpdateSiteIdRoute: typeof BPSitesUpdateSiteIdRoute;
}

const BPRouteChildren: BPRouteChildren = {
  BPCompanyRoute: BPCompanyRouteWithChildren,
  BPLibraryRoute: BPLibraryRouteWithChildren,
  BPForbiddenRoute: BPForbiddenRoute,
  BPIndexRoute: BPIndexRoute,
  BPAssetsAssetIdRoute: BPAssetsAssetIdRoute,
  BPAssetsCreateRoute: BPAssetsCreateRoute,
  BPInspectionsProjectIdRoute: BPInspectionsProjectIdRoute,
  BPInspectionsCreateRoute: BPInspectionsCreateRoute,
  BPSitesSiteIdRoute: BPSitesSiteIdRoute,
  BPSitesCreateRoute: BPSitesCreateRoute,
  BPAssetsUpdateAssetIdRoute: BPAssetsUpdateAssetIdRoute,
  BPInspectionsUpdateProjectIdRoute: BPInspectionsUpdateProjectIdRoute,
  BPSitesUpdateSiteIdRoute: BPSitesUpdateSiteIdRoute,
};

const BPRouteWithChildren = BPRoute._addFileChildren(BPRouteChildren);

interface BRouteChildren {
  BPRoute: typeof BPRouteWithChildren;
}

const BRouteChildren: BRouteChildren = {
  BPRoute: BPRouteWithChildren,
};

const BRouteWithChildren = BRoute._addFileChildren(BRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  BRoute: BRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
